import axios from "axios";
import { useEffect, useState } from "react";

export default function useToken(user) {
  const [token, setToken] = useState("");
  const [generatingToken, setGeneratingToken] = useState(false);

  useEffect(() => {
    if (user) {
      setGeneratingToken(true);

      const email = user?.user?.email,
        name = user?.user?.displayName;

      try {
        axios
          .put(`${process.env.REACT_APP_SERVER_ENDPOINT}/users`, {
            email,
            name,
          })
          .then(({ data }) => {
            const { token } = data;

            localStorage.setItem("token", token);

            setToken(token);
          });
      } catch (error) {
      } finally {
        setGeneratingToken(false);
      }
    }
  }, [user]);

  return [token, generatingToken];
}
